import { NgModule } from '@angular/core';

import { AngularBillboardComponent } from './angular-billboard.component';
import { AngularBillboardService } from './angular-billboard.service';


export class AngularBillboardModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [AngularBillboardComponent],
    providers:    [AngularBillboardService],
    exports:      [AngularBillboardComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
